import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { Button, Flex, IconButton, Menu, MenuButton, MenuItem, MenuList, Spacer, Text } from '@chakra-ui/react'
import { AiOutlineMenu } from 'react-icons/ai'
import { FiLock } from 'react-icons/fi'
import { GoChevronDown } from 'react-icons/go'
import { RiLockPasswordFill } from 'react-icons/ri'

import { authSelector, logout } from '@/stores/auth/authSlice'
import { toggleSidebar } from '@/stores/ui/uiSlice'
import { useNavigate } from 'react-router-dom'

import config, { APP_MODE } from '@/config'

const Header = () => {
  const { user } = useSelector(authSelector)
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const handleLogout = () => {
    dispatch(logout())
    queryClient.clear()
    navigate('/auth/login')
  }

  const handelResetPassword = () => {
    if (!user?._id) {
      toast.error('[Unexpected Error] Missing User Id !')
      return
    }
    navigate(`/users/newPassword?id=${user?._id}`)
  }

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar())
  }
  return (
    <Flex basis="65px" borderBottom="1px solid #d8dbe0" align="center" pl="8">
      <IconButton
        variant="ghost"
        colorScheme="blackAlpha"
        aria-label="Toggle Sidebar"
        icon={<AiOutlineMenu size={20} />}
        onClick={handleToggleSidebar}
      />
      <Spacer />
      {config.mode !== APP_MODE.PRODUCTION && <Text color="red">({config.mode})</Text>}

      <Menu zIndex={'dropdown'} strategy="fixed">
        <MenuButton as={Button} variant="ghost" rightIcon={<GoChevronDown />}>
          Hello, {user?.fullName}
        </MenuButton>
        <MenuList>
          <MenuItem as={Button} variant="ghost" leftIcon={<RiLockPasswordFill />} onClick={handelResetPassword}>
            Reset Password
          </MenuItem>
          <MenuItem as={Button} variant="ghost" leftIcon={<FiLock />} onClick={handleLogout}>
            Log Out
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  )
}

export default Header
